import { Box, HStack, Stack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import {
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../components/TableContent';
import {
  StatusSkeleton,
  TextSkeleton,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { getFixedFeeColumnFlex } from '../../constants';

export const FixedFeeTermDetailsLoadingDesktop: React.FC = () => {
  return (
    <VStack space="stack.xxxs" w="full" pt="stack.xxxs">
      <Box
        h="1px"
        bg={Utils.ColorToken.WithOpacity('brand.primary.principal', 'opacity.semitransparent')}
      />
      <HStack space={0} flex={1}>
        <TableContentItemColumn
          space="stack.quarck"
          flex={getFixedFeeColumnFlex(0) + getFixedFeeColumnFlex(1)}>
          <TableContentItemText color="neutral.medium" fontSize="xs">
            Última atualização do canal
          </TableContentItemText>
          <StatusSkeleton />
        </TableContentItemColumn>
        <TableContentItemColumn space="stack.quarck" flex={getFixedFeeColumnFlex(2)}>
          <TableContentItemText color="neutral.medium" fontSize="xs">
            Iniciado em
          </TableContentItemText>
          <TextSkeleton w="1/4" />
        </TableContentItemColumn>
        <TableContentItemColumn space="stack.quarck" flex={getFixedFeeColumnFlex(3)}>
          <TableContentItemText color="neutral.medium" fontSize="xs">
            Evento
          </TableContentItemText>
          <TextSkeleton w="1/4" />
        </TableContentItemColumn>
        <Stack flex={getFixedFeeColumnFlex(4)} />
        <Stack flex={getFixedFeeColumnFlex(5)} />
        <Stack flex={getFixedFeeColumnFlex(6)} />
        <Stack flex={getFixedFeeColumnFlex(7)} />
      </HStack>
    </VStack>
  );
};
